module.exports = __webpack_public_path__ + "static/img/irole.9131c52.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/jw/irole.png
// module id = t2Jf
// module chunks = 7